import { render, staticRenderFns } from "./changelog-board-status.vue?vue&type=template&id=79f88095"
import script from "./changelog-board-status.vue?vue&type=script&lang=js"
export * from "./changelog-board-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports